/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactActivitySearchResultDto } from '../models/ContactActivitySearchResultDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ContactActivityService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Search contact activities with server-side filtering on typed ContactActivity columns.
     * @param orgGuid
     * @param workflowDefinitionGuids
     * @param includeArchived
     * @param entityGuid
     * @param contactNameSearch
     * @param housingApplicationSearch
     * @param createdByUserGuids
     * @param assignedToUserGuids
     * @param statusCodes
     * @param interactionType
     * @param direction
     * @param isImportant
     * @param dateFrom
     * @param dateTo
     * @param dateField
     * @param primaryEmailSearch
     * @param primaryPhoneSearch
     * @param skip
     * @param take
     * @param ignoreFilters
     * @returns ContactActivitySearchResultDto OK
     * @throws ApiError
     */
    public search(
        orgGuid: string,
        workflowDefinitionGuids?: Array<string>,
        includeArchived: boolean = false,
        entityGuid?: string,
        contactNameSearch?: string,
        housingApplicationSearch?: string,
        createdByUserGuids?: Array<string>,
        assignedToUserGuids?: Array<string>,
        statusCodes?: string,
        interactionType?: string,
        direction?: string,
        isImportant?: boolean,
        dateFrom?: string,
        dateTo?: string,
        dateField?: string,
        primaryEmailSearch?: string,
        primaryPhoneSearch?: string,
        skip?: number,
        take?: number,
        ignoreFilters: boolean = false,
    ): CancelablePromise<ContactActivitySearchResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/ContactActivity/{orgGuid}/Search',
            path: {
                'orgGuid': orgGuid,
            },
            query: {
                'workflowDefinitionGuids': workflowDefinitionGuids,
                'includeArchived': includeArchived,
                'entityGuid': entityGuid,
                'contactNameSearch': contactNameSearch,
                'housingApplicationSearch': housingApplicationSearch,
                'createdByUserGuids': createdByUserGuids,
                'assignedToUserGuids': assignedToUserGuids,
                'statusCodes': statusCodes,
                'interactionType': interactionType,
                'direction': direction,
                'isImportant': isImportant,
                'dateFrom': dateFrom,
                'dateTo': dateTo,
                'dateField': dateField,
                'primaryEmailSearch': primaryEmailSearch,
                'primaryPhoneSearch': primaryPhoneSearch,
                'skip': skip,
                'take': take,
                'ignoreFilters': ignoreFilters,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
